// generated from 26_885 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastSessionSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_session_since_filter"),
  comparison_key: z.enum([
    "4", // 13_725 (51.05%)
    "6", // 7_047 (26.21%)
    "3", // 4_648 (17.29%)
    "5", // 1_465 (5.45%)
  ]),
  display_name: z.string(),
  // undefined: 10_846 (40.34%), defined 16_039 (59.66%)
  raw_value: z
    .union([
      // number samples: 12_717 (79.29%)
      // integer: 11_908 (93.64%)
      // avg: 67.48, min: 0, max: 2562
      z.number().min(0),
      // string samples: 3_322 (20.71%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 20_772 (77.26%)
    // integer: 19_351 (93.16%)
    // avg: 84.18, min: 0, max: 18662
    z.number().min(0),
    // string samples: 6_113 (22.74%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
